module.exports = __webpack_public_path__ + "img/the-bear-chapters_app-icon.2a177b89.png";